import DefaultLayout from './DefaultLayoutContainer';

export default DefaultLayout;
